"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reader_error = void 0;
function reader_error(reason, content) {
    return new Error(reason + " (" + content + ")");
}
exports.reader_error = reader_error;
